package fr.manyverse.app.presentation.components.modules.whiteboard

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Draw
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.whiteboard_restore
import org.jetbrains.compose.resources.stringResource

/**
 * Floating bubble that appears when the whiteboard is minimized.
 * Clicking it restores the whiteboard overlay.
 */
@Composable
fun WhiteboardBubble(
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    FloatingActionButton(
        onClick = onClick,
        containerColor = MaterialTheme.colorScheme.primaryContainer,
        modifier = modifier
    ) {
        Icon(
            imageVector = Icons.Default.Draw,
            contentDescription = stringResource(Res.string.whiteboard_restore)
        )
    }
}
